'use client';

import { ReactNode } from 'react';
import { PageContext, type PageContextValues } from './PageContext';

interface PageContentProps {
  accent?: PageContextValues['accent'];
  children: ReactNode;
  heroBleedSize?: PageContextValues['heroBleedSize'];
}

export function PageContainer({ accent = false, children, heroBleedSize }: PageContentProps) {
  return (
    <PageContext.Provider
      value={{ accent, heroBleedSize: heroBleedSize ? heroBleedSize : accent ? 'md' : 'none' }}
    >
      <main
        className="
          grid
          grid-rows-[1fr]
          min-h-full
          px-layout-sm md:px-layout-md
        "
      >
        <div>
          <div
            className="
              bg-bg-layout-subtle-default
              grid
              grid-rows-[1fr]
              mx-auto
              rounded-layout-lg
              min-h-full
              max-w-[1232px]
            "
          >
            <div>{children}</div>
          </div>
        </div>
      </main>
    </PageContext.Provider>
  );
}
